import styled from "styled-components";

export const StyledHorizontalLine = styled('div')(({ theme }) => ({
    color: theme.CorporateTheme?.colors?.border,
    borderBottom: `0.5px solid ${theme.CorporateTheme?.colors?.border}`,
}));
